"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _index = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown/index"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var emailVariables = {
  mention: {
    subject: [{
      name: '{topic_title}',
      description: 'The title of the topic'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{author_username}',
      description: 'The username of the author of the reply containing the @mention'
    }, {
      name: '{topic_title}',
      description: 'The title of the topic'
    }, {
      name: '{post_url}',
      description: 'The URL of the topic (or reply within the topic)'
    }, {
      name: '{post_content}',
      description: 'Preview snippet of the topic or reply with the @mention'
    }, {
      name: '{unsubscribe_url}',
      description: 'A one-click URL for the user to unsubscribe from @mention notification emails.'
    }]
  },
  'account-approved': {
    subject: [{
      name: '{community_name}',
      description: 'The name of the community'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The name of the recipient'
    }]
  },
  'activate-account': {
    subject: [{
      name: '{community_name}',
      description: 'The name of the community'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{activation_url}',
      description: 'An auto-generated URL for the user to confirm their account'
    }, {
      name: '{manual_activation_url}',
      description: 'The URL a user can use to manually activate their account as a backup, if the auto-generated URL cannot be used.'
    }, {
      name: '{activation_code}',
      description: 'The auto-generated token to use for account activation.'
    }]
  },
  'new-topic': {
    subject: [{
      name: '{category_title}',
      description: 'The title of the category where the new topic was created'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{author_username}',
      description: 'The username of the topic author'
    }, {
      name: '{topic_title}',
      description: 'The title of the new topic'
    }, {
      name: '{category_title}',
      description: 'The title of the category where the new topic was created'
    }, {
      name: '{category_url}',
      description: 'The URL of the category where the new topic was created'
    }, {
      name: '{topic_url}',
      description: 'The URL of the topic'
    }, {
      name: '{topic_content}',
      description: 'Preview snippet of the topic'
    }, {
      name: '{community_name}',
      description: 'The name of your community'
    }, {
      name: '{community_homepage_url}',
      description: 'The homepage URL of your community'
    }, {
      name: '{unsubscribe_url}',
      description: 'A one-click URL for the user to unsubscribe from  new topic emails.'
    }, {
      name: '{content_type}',
      description: 'The type of content created (e.g., Topic, Question)'
    }]
  },
  'new-reply': {
    subject: [{
      name: '{topic_title}',
      description: 'Title of the topic'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{author_username}',
      description: 'The username of the author of the new reply'
    }, {
      name: '{reply_url}',
      description: 'The URL of the reply'
    }, {
      name: '{topic_title}',
      description: 'The title of the topic where the reply is posted'
    }, {
      name: '{reply_content}',
      description: 'Preview snippet of the reply'
    }, {
      name: '{unsubscribe_url}',
      description: 'A one-click URL for the user to unsubscribe from  new reply emails.'
    }, {
      name: '{content_type}',
      description: 'The type of content where the reply is posted (e.g., Topic, Question)'
    }]
  },
  'private-message': {
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{sender_username}',
      description: 'The username of the private message sender'
    }, {
      name: '{pm_url}',
      description: 'The URL of the private message'
    }, {
      name: '{unsubscribe_url}',
      description: 'A one-click URL for the user to unsubscribe from private message notification emails.'
    }]
  },
  'reset-password': {
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{password_reset_url}',
      description: 'The URL for a user to reset their password'
    }]
  },
  'topic-answered': {
    subject: [{
      name: '{question_title}',
      description: 'The title of the question'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{answer_url}',
      description: 'The URL of the reply that was marked as the answer'
    }, {
      name: '{question_title}',
      description: 'The title of the question'
    }, {
      name: '{answer_content}',
      description: 'Preview snippet of the answer'
    }, {
      name: '{author_username}',
      description: 'The username of the author whose reply got marked as the best answer'
    }, {
      name: '{unsubscribe_url}',
      description: 'A one-click URL for the user to unsubscribe from answer marked notification emails.'
    }]
  },
  'account-activate': {
    subject: [{
      name: '{community_name}',
      description: 'The name of the community'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The name of the recipient'
    }]
  },
  'application-approved': {
    subject: [{
      name: '{group_name}',
      description: 'The name of the group'
    }],
    body: [{
      name: '{username}',
      description: 'Username'
    }, {
      name: '{group_name}',
      description: 'The name of the group'
    }, {
      name: '{group_url}',
      description: 'The URL of the group'
    }]
  },
  'join-community-invite': {
    subject: [{
      name: '{inviter_username}',
      description: 'The username of the invitation sender'
    }, {
      name: '{community_name}',
      description: 'The name of the community'
    }],
    body: [{
      name: '{contact_name}',
      description: 'The first and last name of the Contact'
    }, {
      name: '{community_name}',
      description: 'The name of the community'
    }, {
      name: '{custom_message}',
      description: 'The custom message added by the user who sent the invite'
    }, {
      name: '{invite_url}',
      description: 'An auto-generated URL for the user to complete registration on the community'
    }, {
      name: '{community_url}',
      description: 'The homepage URL of your community'
    }]
  },
  'join-group-invite': {
    subject: [{
      name: '{inviter_username}',
      description: 'The username of the invitation sender'
    }, {
      name: '{group_name}',
      description: 'The name of the group'
    }, {
      name: '{community_name}',
      description: 'The name of the community'
    }],
    body: [{
      name: '{contact_name}',
      description: 'The first and last name of the Contact'
    }, {
      name: 'inviter_username',
      description: 'The username of the invitation sender'
    }, {
      name: 'group_name',
      description: 'The name of the group'
    }, {
      name: '{community_name}',
      description: 'The name of the community'
    }, {
      name: 'group_description',
      description: 'The description text of this group'
    }, {
      name: 'group_thumbnail',
      description: 'The URL of the thumbnail image of the group'
    }, {
      name: '{custom_message}',
      description: 'The custom message added by the user who sent the invite'
    }, {
      name: '{invite_url}',
      description: 'An auto-generated URL for the user to join the group'
    }, {
      name: '{community_url}',
      description: 'The homepage URL of your community'
    }]
  },
  'mark-answer-reminder': {
    subject: [{
      name: 'question_title',
      description: 'The title of the question'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{question_title}',
      description: 'The title of the question'
    }, {
      name: '{question_url}',
      description: 'The URL of the question'
    }, {
      name: '{unsubscribe_url}',
      description: 'A one-click URL for the user to unsubscribe from new reply/is your problem solved emails.'
    }]
  },
  'new-product-update-published': {
    subject: [{
      name: '{topic_title}',
      description: 'Title of the new prodcut update'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{author_username}',
      description: 'The username of the author'
    }, {
      name: '{topic_title}',
      description: 'Title of the new product update'
    }, {
      name: '{topic_content}',
      description: 'Preview snippet of the topic'
    }, {
      name: '{unsubscribe_url}',
      description: 'A one-click URL for the user to unsubscribe from new product update emails.'
    }]
  },
  'new-event-created': {
    subject: [{
      name: '{event_name}',
      description: 'Name of the event'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{event_time}',
      description: 'The date and time of the event'
    }, {
      name: '{event_name}',
      description: 'Name of the event'
    }, {
      name: '{event_url}',
      description: 'The URL of the event'
    }, {
      name: '{unsubscribe_url}',
      description: 'A one-click URL for the user to unsubscribe from new event emails'
    }]
  },
  'dsa-moderation': {
    subject: [{
      name: '{topic_title}',
      description: 'Title of the topic'
    }],
    body: [{
      name: '{recipient_username}',
      description: 'The username of the recipient'
    }, {
      name: '{moderator_description}',
      description: 'The description of the moderation action taken by the moderator'
    }, {
      name: '{moderation_reason}',
      description: 'The reason for the moderation action taken by the moderator'
    }, {
      name: '{topic_title}',
      description: 'Title of the topic'
    }, {
      name: '{post_url}',
      description: 'The URL of the post'
    }]
  }
};

var EmailVariablesDropdown = function EmailVariablesDropdown(_ref) {
  var emailType = _ref.emailType,
      isSubject = _ref.isSubject,
      onItemSelect = _ref.onItemSelect;
  var variablesMap = emailVariables[emailType];

  if (!variablesMap) {
    return null;
  }

  var variables = isSubject ? variablesMap.subject : variablesMap.body;
  return variables ? (0, _preact.h)(_index.default, {
    size: "S",
    align: "right",
    popupName: "insert-email-variables-list",
    trigger: (0, _preact.h)("div", {
      className: "insert-email-variables-trigger"
    }, "Insert variables"),
    closeOnDropdownClick: true
  }, variables.map(function (item) {
    return (0, _preact.h)(_index.DropdownItem, {
      key: item.name,
      onClick: function onClick() {
        onItemSelect(item.name);
      },
      "data-element-name": "dropdown item ".concat(item.name),
      "data-track-type": "click"
    }, (0, _preact.h)("div", null, (0, _preact.h)("div", {
      className: "email-variable"
    }, item.name), (0, _preact.h)("div", {
      className: "email-variable-description"
    }, item.description)));
  })) : null;
};

var _default = EmailVariablesDropdown;
exports.default = _default;